import useSWR from "swr"
import { GovernanceConfigApi } from "../../../apis"
import { usePermission } from "../../permission"

/** Backend defaults (constants/SHORTAGE_DECISION.ts) when the tenant has no config or the user may not read it. */
export const DEFAULT_THRESHOLDS = { review: 5, escalation: 30 }

export type ShortageDecisionCode = "NONE" | "AUTO_SPLIT" | "COORDINATOR_REVIEW" | "MANAGER_ESCALATION"

export function useShortageThresholds() {
  const BIZ_GOV_VIEW = usePermission("BIZ_GOV_VIEW")
  const { data } = useSWR(BIZ_GOV_VIEW.hasAccess ? ["governance-config-thresholds"] : null, () => GovernanceConfigApi.get(), { revalidateOnFocus: false })
  return {
    review: data?.shortageReviewThresholdPercent ?? DEFAULT_THRESHOLDS.review,
    escalation: data?.shortageEscalationThresholdPercent ?? DEFAULT_THRESHOLDS.escalation,
  }
}

/** Same bands as the backend (logics/shortage/evaluate-decision.ts). */
export function decisionFor(percent: number, shortLines: number, t: { review: number; escalation: number }): ShortageDecisionCode {
  if (shortLines === 0) return "NONE"
  if (percent < t.review) return "AUTO_SPLIT"
  if (percent <= t.escalation) return "COORDINATOR_REVIEW"
  return "MANAGER_ESCALATION"
}
